import site from '../../site';
import actionTypes from '../constants/action-types';
import loadPage from '../helpers/load-page';
import { UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';
import settingsKeys from '../../globals/constants/settings';

const viewReloader = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.INSERT_ELEMENT:
    case actionTypes.INSERT_BLOCK:
    case actionTypes.CUT_ELEMENT:
    case actionTypes.PASTE_ELEMENT:
    case actionTypes.DUPLICATE_ELEMENT:
    case actionTypes.DELETE_ELEMENT:
    case actionTypes.REPLACE_ELEMENT:
    case actionTypes.SHIFT_ELEMENT:
    case actionTypes.SET_ELEMENT_ATTRIBUTE:
    case actionTypes.REMOVE_ELEMENT_ATTRIBUTE:
    case actionTypes.SYNCHRONIZE_ELEMENT:
    case actionTypes.SET_CHILDREN_PRESENCE:
    case actionTypes.BULK_SET_CHILDREN_PRESENCE:
    case actionTypes.BULK_VIEW_ACTIONS: {
      const { strategy, skipViewReload } = action.payload.options || {};
      const isViewReloadRequired = strategy === UPDATE_STATIC_ONLY && !skipViewReload;

      if (isViewReloadRequired) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);
        if (pageId) {
          const page = site.selectors.getPage(state, pageId);
          loadPage(store.dispatch, page);
        }
      }

      next(action);
      break;
    }

    case site.actionTypes.SET_ACTIVE_PAGE: {
      const state = store.getState();
      const page = site.selectors.getPage(state, action.payload.pageId);

      next(action);
      loadPage(store.dispatch, page);
      action.payload.resolve && action.payload.resolve();
      break;
    }

    case actionTypes.CHANGE_HTML:
    case actionTypes.FORCE_RELOAD_VIEW: {
      const state = store.getState();
      const pageId = site.selectors.getActivePageId(state);
      if (pageId) {
        const page = site.selectors.getPage(state, pageId);
        if (page.html) {
          loadPage(store.dispatch, page);
        }
      }

      next(action);
      break;
    }

    case site.actionTypes.UPDATE_SETTINGS: {
      next(action);

      const {
        settings,
        options: { firstInitiation },
      } = action.payload;

      const shouldReloadView = [
        settingsKeys.IS_COOKIE_BANNER_ENABLED,
        settingsKeys.BUSINESS_NAME,
        settingsKeys.PHONES,
        settingsKeys.ADDRESSES,
        settingsKeys.EMAILS,
        settingsKeys.BUSINESS_HOURS,
      ].some((setting) => setting in settings);
      const state = store.getState();
      const pageId = site.selectors.getActivePageId(state);

      if (firstInitiation) break;

      if (shouldReloadView && pageId) {
        const page = site.selectors.getPage(state, pageId);
        loadPage(store.dispatch, page);
      }
      break;
    }

    default: {
      next(action);
      break;
    }
  }
};

export default viewReloader;
